'use client';

import {
  AppProgressProvider,
  useProgress,
  useRouter as useProgressRouter,
} from '@bprogress/next';

export { AppProgressProvider, useProgress, useProgressRouter };
